var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Box, Divider, IconButton, Paper, Popover, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import FullProfileDetails from "./FullProfileDetails";
import ProfilePreview from "./ProfilePreview";
import ProfileListActions from "./fullProfile/ProfileListActions";
import { useShowNewProfile } from "./newProfileToggle";
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import BusinessIcon from '@mui/icons-material/Business';
import CakeIcon from '@mui/icons-material/Cake';
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import FlagIcon from '@mui/icons-material/Flag';
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import { alpha } from "@mui/material/styles";
import { useCurrentSector } from "../../utils/hooks/sector/useSectors";
import { useReadOnly } from "../../utils/hooks/users/useReadOnly";
import { formatFullDate } from "../../utils/date.util";
import LabeledValue from "../LabeledValue";
import { GenderType, getCurrentStay } from "../../models/profile/profile.model";
import { birthdayToAge, getProfileAllergies, getProfileFoodDiets, getProfileMedicalString } from "../../utils/profile.util";
import { getCountryNameForISO2 } from "../../utils/country.utils";
import { CommonThemeColors } from "../theme";
import { getScaledUrl, MediaSize } from "../../utils/media.util";
import ReservationPastVisits from "./ReservationPastVisits";
import Button from "@mui/material/Button";
import InfoIcon from "@mui/icons-material/Info";
import { labelizeUnderScoreText, useLocalize } from "../../utils/text.util";
import ReplayIcon from '@mui/icons-material/Replay';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import EditIcon from '@mui/icons-material/Edit';
import ProfileQuickPreferenceEditor from "./ProfileQuickPreferenceEditor";
import { COMMON_PREFERENCE_TYPES } from "../../models/profile/preference.model";
import { getGuestStayStatusInfo, getStatusColorBasedOnGuestStayInfo } from "../../utils/color.util";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProfileQuickContactEditor from "./ProfileQuickContactEditor";
import { AllergyElement } from "../uiElements/AllergyElement";
import { DietElement } from "../uiElements/DietElement";
import { MedicalElement } from "../uiElements/MedicalElement";
import { ElementChip } from "../uiElements/base/ElementChip";
import { ElementChipList } from "../uiElements/base/ElementChipList";
import { AccommodationElement } from "../uiElements/ResourceElement";
import { StayStatusElement } from "../uiElements/StayStatusElement";
import { getIconForLanguage, getLocalizedLangLabel } from "../../utils/translations.util";
import { InterestElement } from "../uiElements/InterestElement";
var BIRTHDAY_COLOR = "#D56E9B";
function ProfileBirthdayElement(_a) {
    var label = _a.label;
    if (!label)
        return null;
    return (_jsx(ElementChip, { text: label, startIcon: _jsx(CakeIcon, { sx: { fontSize: 16, color: BIRTHDAY_COLOR } }), borderColor: alpha(BIRTHDAY_COLOR, 0.28) }));
}
function ProfileLanguageElement(_a) {
    var languageCode = _a.languageCode, locale = _a.locale;
    var _b = useState(false), hasIconError = _b[0], setHasIconError = _b[1];
    var normalizedLanguageCode = languageCode.trim();
    if (!normalizedLanguageCode)
        return null;
    var label = getLocalizedLangLabel(normalizedLanguageCode, locale);
    var iconUrl = getIconForLanguage(normalizedLanguageCode);
    var startIcon = iconUrl && !hasIconError
        ? (_jsx(Box, { component: "img", src: iconUrl, alt: "", "aria-hidden": "true", onError: function () { return setHasIconError(true); }, sx: {
                display: "block",
                width: 18,
                height: 18,
                borderRadius: "50%",
                objectFit: "cover",
            } }))
        : _jsx(FlagIcon, { sx: { fontSize: 16, color: "text.secondary" } });
    return _jsx(ElementChip, { text: label || normalizedLanguageCode, startIcon: startIcon });
}
var profileScopedListUrl = function (pathname, profileId) {
    return "".concat(pathname, "?").concat(new URLSearchParams({ profileId: profileId !== null && profileId !== void 0 ? profileId : '' }).toString());
};
var ReservationProfile = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var t = useTranslation().t;
    var _h = useLocalize(), tFallback = _h.tFallback, userLanguage = _h.language;
    // Read-only users may view a profile on the reservation, but not remove it.
    var readOnly = useReadOnly();
    var profile = props.profile;
    var sector = useCurrentSector();
    var simple = props.mode === 'simple';
    var _j = useState(null), anchorElPreference = _j[0], setAnchorElPreference = _j[1];
    var _k = useState(null), anchorElContact = _k[0], setAnchorElContact = _k[1];
    var openPreferenceEditor = Boolean(anchorElPreference);
    var openContactEditor = Boolean(anchorElContact);
    var _l = useState(undefined), voiceNoteId = _l[0], setVoiceNoteId = _l[1];
    var _m = useState(), copied = _m[0], setCopied = _m[1];
    // The rewrite opens by default in development; production keeps this sidebar until the rewrite has everything.
    var showNewProfile = useShowNewProfile();
    var searchParams = useSearchParams()[0];
    var stayStatusColor = getStatusColorBasedOnGuestStayInfo(props.profile)[0];
    useEffect(function () {
        var _a;
        setVoiceNoteId((_a = searchParams.get('voiceNoteId')) !== null && _a !== void 0 ? _a : undefined);
    }, [searchParams]);
    var handleOpenQuickPreferenceEditor = function (anchorElement) {
        setAnchorElPreference(anchorElement);
    };
    var handleOpenQuickContactEditor = function (anchorElement) {
        setAnchorElContact(anchorElement);
    };
    var handleClosePreferenceEditor = function () {
        setAnchorElPreference(null);
    };
    var handleCloseContactEditor = function () {
        setAnchorElContact(null);
    };
    if (!profile) {
        return null;
    }
    var renderBirthdate = function () {
        if (!(profile === null || profile === void 0 ? void 0 : profile.birthDay))
            return null;
        var birthday = new Date(profile.birthDay);
        var today = new Date();
        var years = birthdayToAge(profile === null || profile === void 0 ? void 0 : profile.birthDay);
        var formattedBirthday = formatFullDate(birthday);
        var text = "".concat(formattedBirthday, " (").concat(years, ")");
        var isBirthdayToday = birthday.getDate() === today.getDate()
            && birthday.getMonth() === today.getMonth();
        return (_jsx(LabeledValue, __assign({ label: t('Birthday') }, { children: isBirthdayToday
                ? _jsx(ProfileBirthdayElement, { label: text })
                : _jsx(ElementChip, { text: text }) })));
    };
    var renderLanguages = function () {
        var _a;
        var uniqueLanguages = new Map();
        var addLanguage = function (language) {
            var trimmedLanguage = language === null || language === void 0 ? void 0 : language.trim();
            var normalizedLanguage = trimmedLanguage === null || trimmedLanguage === void 0 ? void 0 : trimmedLanguage.toLowerCase();
            if (trimmedLanguage && normalizedLanguage && !uniqueLanguages.has(normalizedLanguage)) {
                uniqueLanguages.set(normalizedLanguage, trimmedLanguage);
            }
        };
        addLanguage(profile.languageCode);
        (_a = profile.additionalLanguages) === null || _a === void 0 ? void 0 : _a.forEach(addLanguage);
        var languages = Array.from(uniqueLanguages.values());
        if (languages.length === 0)
            return null;
        return (_jsx(LabeledValue, __assign({ label: t('Language') }, { children: _jsx(Stack, __assign({ direction: "row", flexWrap: "wrap", gap: 1 }, { children: languages.map(function (language) { return (_jsx(ProfileLanguageElement, { languageCode: language, locale: userLanguage }, language.toLowerCase())); }) })) })));
    };
    var renderAddresses = function () {
        var _a, _b;
        var primary = ((_a = profile === null || profile === void 0 ? void 0 : profile.addresses) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.isPrimary && !a.hidden; })) || ((_b = profile === null || profile === void 0 ? void 0 : profile.addresses) === null || _b === void 0 ? void 0 : _b.find(function (a) { return !a.hidden; }));
        var addressText = '-';
        if (primary) {
            var value = [];
            if (primary.addressLine1) {
                value.push(primary.addressLine1);
            }
            if (primary.postalCode || primary.cityName) {
                value.push([primary.postalCode, primary.cityName].filter(function (x) { return !!x; }).join(', '));
            }
            if (primary.countryCode) {
                value.push(getCountryNameForISO2(primary.countryCode));
            }
            addressText = value.join('\n');
        }
        return (_jsx(LabeledValue, __assign({ label: t('Address') }, { children: _jsx(Typography, __assign({ variant: 'body2', sx: { whiteSpace: 'pre-wrap' } }, { children: addressText })) })));
    };
    var renderCompany = function () {
        var _a, _b;
        var companyName = (_b = (_a = profile === null || profile === void 0 ? void 0 : profile.company) === null || _a === void 0 ? void 0 : _a.companyName) === null || _b === void 0 ? void 0 : _b.trim();
        if (!companyName)
            return null;
        return (_jsx(LabeledValue, __assign({ label: t('Company') }, { children: _jsx(ElementChip, { text: companyName, startIcon: _jsx(BusinessIcon, { sx: { fontSize: 16, color: 'text.secondary' } }) }) })));
    };
    var renderPastVisits = function () {
        return (_jsx(LabeledValue, __assign({ label: t('Past visits') }, { children: _jsx(ReservationPastVisits, { profile: props.profile }) })));
    };
    var renderProfileActions = function () {
        return (_jsxs(Stack, __assign({ gap: 1 }, { children: [!props.onDelete && !props.onChangeExpand &&
                    _jsx(Stack, __assign({ direction: 'row', gap: 1 }, { children: _jsx(Button, __assign({ variant: 'outlined', href: profileScopedListUrl('/system/marketingStatistics', profile.id), target: '_blank', rel: 'noopener noreferrer', disabled: !profile.id }, { children: t('Marketing') })) })), !props.onDelete && !props.onChangeExpand &&
                    _jsx(Stack, __assign({ direction: 'row', gap: 1 }, { children: _jsx(Button, __assign({ variant: 'outlined', href: profileScopedListUrl('/system/reservations', profile.id), target: '_blank', rel: 'noopener noreferrer', disabled: !profile.id }, { children: t('Bookings') })) })), !props.onDelete && !props.onChangeExpand &&
                    _jsx(Stack, __assign({ direction: 'row', gap: 1 }, { children: _jsx(Button, __assign({ variant: 'outlined', href: profileScopedListUrl('/system/folios', profile.id), target: '_blank', rel: 'noopener noreferrer', disabled: !profile.id }, { children: t('Folios') })) })), !props.onDelete && !props.onChangeExpand && props.extraActions, _jsxs(Stack, __assign({ direction: 'row', sx: {
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: 200,
                        marginTop: 'auto',
                        alignSelf: 'center'
                    } }, { children: [!!props.onDelete &&
                            _jsxs(IconButton, __assign({ onClick: props.onDelete, disabled: readOnly, sx: {
                                    borderRadius: 0
                                } }, { children: [_jsx(CancelIcon, { sx: {
                                            color: CommonThemeColors.sys.action.active,
                                            mr: 1
                                        } }), _jsx(Typography, __assign({ variant: 'h6', sx: {
                                            mt: 0.4
                                        } }, { children: t('Remove') }))] })), !!props.onChangeExpand &&
                            _jsx(IconButton, __assign({ sx: {
                                    marginLeft: 'auto',
                                    borderRadius: 0
                                }, onClick: props.onChangeExpand }, { children: props.mode === 'full' ? (_jsxs(_Fragment, { children: [_jsx(CloseFullscreenIcon, { sx: {
                                                color: CommonThemeColors.sys.action.active,
                                                mr: 1
                                            } }), _jsx(Typography, __assign({ variant: 'h6', sx: {
                                                mt: 0.4
                                            } }, { children: t('Close') }))] })) : (_jsxs(_Fragment, { children: [_jsx(OpenInFullIcon, { sx: {
                                                color: CommonThemeColors.sys.action.active,
                                                mr: 1
                                            } }), _jsx(Typography, __assign({ variant: 'h6', sx: {
                                                mt: 0.4
                                            } }, { children: t('Open') }))] })) }))] }))] })));
    };
    var renderSectorSpecificInfo = function () {
        var allergies = getProfileAllergies(profile);
        var diets = getProfileFoodDiets(profile);
        var medicalItems = getProfileMedicalString(profile);
        var collator = new Intl.Collator(userLanguage, {
            numeric: true,
            sensitivity: 'base',
        });
        var byLabel = function (left, right) { return (collator.compare(left.label, right.label)); };
        var buildPreferenceItems = function (preferences, translationKeyPrefix) {
            var itemsByValue = new Map();
            preferences.forEach(function (preference) {
                var value = preference.preferenceValue;
                if (!value)
                    return;
                var active = Boolean(voiceNoteId) && preference.voiceNoteId === voiceNoteId;
                var existing = itemsByValue.get(value);
                if (existing) {
                    existing.active = existing.active || active;
                    return;
                }
                itemsByValue.set(value, {
                    value: value,
                    label: tFallback("".concat(translationKeyPrefix, "_").concat(value), labelizeUnderScoreText(value)),
                    active: active,
                });
            });
            return Array.from(itemsByValue.values()).sort(byLabel);
        };
        var allergyItems = buildPreferenceItems(allergies, COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY);
        var dietItems = buildPreferenceItems(diets, COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE);
        var sortedMedicalItems = Array.from(new Set(medicalItems))
            .map(function (value) { return ({
            value: value,
            label: tFallback("Common health preference value ".concat(value), labelizeUnderScoreText(value)),
        }); })
            .sort(byLabel);
        var hasPreferences = allergyItems.length > 0
            || dietItems.length > 0
            || sortedMedicalItems.length > 0;
        var preferenceAction = hasPreferences
            ? (_jsx(IconButton, __assign({ size: "small", color: "primary", "aria-label": t('Edit'), onClick: function (event) { return handleOpenQuickPreferenceEditor(event.currentTarget); }, disabled: readOnly }, { children: _jsx(EditIcon, { sx: { fontSize: '14px' } }) })))
            : (_jsx(ElementChip, { text: t('Add'), variant: "ghost", startIcon: _jsx(AddIcon, { sx: { fontSize: 16, color: CommonThemeColors.sys.primary.main } }), onClick: handleOpenQuickPreferenceEditor, disabled: readOnly }));
        return (_jsx(LabeledValue, __assign({ label: t('Allergies, Diets, Medical') }, { children: _jsxs(Stack, __assign({ direction: 'row', flexWrap: 'wrap', gap: 1 }, { children: [allergyItems.map(function (allergy) { return (_jsx(AllergyElement, { label: allergy.label, value: allergy.value, active: allergy.active }, "allergy-".concat(allergy.value))); }), dietItems.map(function (diet) { return (_jsx(DietElement, { label: diet.label, value: diet.value, active: diet.active }, "diet-".concat(diet.value))); }), sortedMedicalItems.map(function (medical) { return (_jsx(MedicalElement, { label: medical.label, value: medical.value }, "medical-".concat(medical.value))); }), preferenceAction] })) })));
    };
    var profileInitials = [profile.firstName, profile.lastName]
        .map(function (name) { var _a; return (_a = name === null || name === void 0 ? void 0 : name.trim().charAt(0)) !== null && _a !== void 0 ? _a : ''; })
        .join('')
        .toUpperCase() || '?';
    var isChild = !!profile.birthDay && birthdayToAge(profile.birthDay) < 18;
    var gender = (_a = profile.gender) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var profileAvatarBackground = gender === GenderType.MALE
        ? isChild ? '#9EC3F0' : '#4E82D4'
        : gender === GenderType.FEMALE
            ? isChild ? '#EFAAC5' : '#D56E9B'
            : isChild ? '#B7C0CE' : '#828EA6';
    var renderProfileOverview = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var currentStay = getCurrentStay(profile);
        /*
            Casablanca names its accommodation services after the opaque rate string it streams, so
            rateCode reads "PMS_RGG25ZID" on those properties. mealCode is the readable board code
            the property mapped that rate to; it is unset for every other PMS and for rates nobody
            has mapped, which keeps the raw code visible exactly as before.
        */
        var rateLabel = (currentStay === null || currentStay === void 0 ? void 0 : currentStay.mealCode) || (currentStay === null || currentStay === void 0 ? void 0 : currentStay.rateCode);
        // One resolved stay drives both the label and its dates, so a skipped pending stay can never
        // leak its dates into the tooltip of the stay that was labelled instead.
        var stayStatusInfo = getGuestStayStatusInfo(profile);
        var stayStatus = stayStatusInfo === null || stayStatusInfo === void 0 ? void 0 : stayStatusInfo.status;
        var statusStay = stayStatusInfo === null || stayStatusInfo === void 0 ? void 0 : stayStatusInfo.stay;
        /*
            completedStaysNo counts only the stays the guest turned up for. The fallbacks below
            count every reservation record on the profile — PMS enquiries and waiting-list entries
            included — which badged enquiry-heavy guests as "Regular" off bookings they never
            took. They stay as fallbacks for profiles not yet touched by a smart-data sync.
        */
        var totalStays = (_f = (_e = (_d = (_a = profile.completedStaysNo) !== null && _a !== void 0 ? _a : (_c = (_b = profile.smartData) === null || _b === void 0 ? void 0 : _b.stays) === null || _c === void 0 ? void 0 : _c.totalStays) !== null && _d !== void 0 ? _d : profile.allStaysNo) !== null && _e !== void 0 ? _e : profile.guestDialogStaysNo) !== null && _f !== void 0 ? _f : 0;
        var isRegular = totalStays >= 2;
        var staysLabel = "".concat(t('Stays'), ": ").concat(totalStays);
        var visitHistoryLabel = isRegular
            ? "".concat(t('Regular'), " \u00B7 ").concat(staysLabel)
            : staysLabel;
        return (_jsxs(Stack, __assign({ direction: 'row', alignItems: 'flex-start', pt: '12px', pb: '12px' }, { children: [_jsx(Avatar, __assign({ src: getScaledUrl((_g = props.profile) === null || _g === void 0 ? void 0 : _g.avatar, MediaSize.MEDIUM_300, MediaSize.MEDIUM_300), sx: {
                        width: 72,
                        height: 72,
                        flexShrink: 0,
                        borderRadius: '8px',
                        bgcolor: profileAvatarBackground,
                        mr: '8px',
                        userSelect: 'none'
                    } }, { children: _jsx(Typography, __assign({ variant: "h4", sx: { mt: 0.5, color: '#fff', fontWeight: 600 } }, { children: profileInitials })) })), _jsxs(Stack, __assign({ gap: 0.5, alignItems: 'flex-start', minWidth: 0 }, { children: [_jsx(StayStatusElement, { stayStatus: stayStatus, startDate: statusStay === null || statusStay === void 0 ? void 0 : statusStay.startDay, endDate: statusStay === null || statusStay === void 0 ? void 0 : statusStay.endDay }), _jsxs(ElementChipList, { children: [!!(currentStay === null || currentStay === void 0 ? void 0 : currentStay.roomId) && (_jsx(AccommodationElement, { name: currentStay.roomId })), !!rateLabel && (_jsx(ElementChip, { text: rateLabel, startIcon: _jsx(SellOutlinedIcon, { sx: { fontSize: 15, color: '#55C3C1' } }) })), !currentStay && !stayStatus && (_jsx(ElementChip, { text: t('No active stay'), startIcon: _jsx(InfoIcon, { sx: { fontSize: 15, color: 'text.secondary' } }) })), _jsx(ElementChip, { text: visitHistoryLabel, startIcon: isRegular
                                        ? _jsx(ReplayIcon, { sx: { fontSize: 15, color: '#55C3C1' } })
                                        : _jsx(NewReleasesIcon, { sx: { fontSize: 15, color: '#55C3C1' } }) })] })] }))] })));
    };
    var renderAiGeneratedInterests = function () {
        var _a, _b;
        var interests = (_b = (_a = profile.preferences) === null || _a === void 0 ? void 0 : _a.filter(function (preference) { return preference.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_AI_GENERATED_INTERESTS
            && !!preference.preferenceValue; })) !== null && _b !== void 0 ? _b : [];
        if (interests.length === 0)
            return null;
        return (_jsx(LabeledValue, __assign({ label: t('AI generated interests') }, { children: _jsx(ElementChipList, { children: interests.map(function (interest, index) { return (_jsx(InterestElement, { label: tFallback("".concat(COMMON_PREFERENCE_TYPES.CRQLAR_AI_GENERATED_INTERESTS, "_").concat(interest.preferenceValue), labelizeUnderScoreText(interest.preferenceValue)), value: interest.preferenceValue, aiGenerated: true }, "".concat(interest.preferenceValue, "-").concat(index))); }) }) })));
    };
    var simpleModeUI = (_jsxs(Stack, __assign({ sx: {
            width: "100%",
            gap: '16px',
            padding: '16px 16px',
            '@media (min-width:768px)': {
                // Changed regular width to 400px for full mode
                width: props.mode === 'full' ? "400px" : '100%'
            }
        } }, { children: [renderProfileOverview(), renderAiGeneratedInterests(), _jsx(Divider, {}), _jsxs(Stack, __assign({ sx: { gap: 1.5 } }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', fontWeight: 500 }, { children: t('Personal information') })), _jsxs(Stack, __assign({ sx: { gap: 1.5 } }, { children: [renderBirthdate(), renderLanguages(), renderCompany(), renderSectorSpecificInfo()] }))] })), _jsx(Divider, {}), _jsxs(Stack, __assign({ sx: {
                    gap: 2
                } }, { children: [_jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', spacing: 1 }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', fontWeight: 500, mb: -0.5, mt: 1 }, { children: t('Contact information') })), _jsx(IconButton, __assign({ size: 'small', color: 'primary', onClick: function (event) { return handleOpenQuickContactEditor(event.currentTarget); }, disabled: readOnly }, { children: _jsx(EditIcon, { sx: { fontSize: '14px' } }) }))] })), _jsx(LabeledValue, __assign({ label: t('Email') }, { children: _jsx(Typography, __assign({ variant: 'body2', sx: { whiteSpace: 'pre-wrap' } }, { children: ((_c = (_b = profile === null || profile === void 0 ? void 0 : profile.emails) === null || _b === void 0 ? void 0 : _b.filter(function (e) { return !!e.email && !e.hidden; })) === null || _c === void 0 ? void 0 : _c.map(function (e) { var _a; return (_a = e.email) === null || _a === void 0 ? void 0 : _a.toLowerCase(); }).join('\n')) || '-' })) })), _jsx(LabeledValue, __assign({ label: t('Phone number') }, { children: _jsx(Typography, __assign({ variant: 'body2', sx: { whiteSpace: 'pre-wrap' } }, { children: ((_f = (_e = (_d = profile === null || profile === void 0 ? void 0 : profile.phones) === null || _d === void 0 ? void 0 : _d.filter(function (p) { return !!p.phoneNumberFull && !p.hidden; })) === null || _e === void 0 ? void 0 : _e.map(function (p) { return p.phoneNumberFull; })) === null || _f === void 0 ? void 0 : _f.join('\n')) || '-' })) })), renderAddresses()] })), _jsx(Divider, {}), _jsxs(Stack, __assign({ sx: {
                    gap: 2
                } }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', mb: -0.5, fontWeight: 500 }, { children: t('Bookings') })), renderPastVisits()] })), _jsx(Divider, {}), renderProfileActions(), _jsx(Popover, __assign({ open: openPreferenceEditor, anchorEl: anchorElPreference, onClose: handleClosePreferenceEditor, anchorOrigin: {
                    vertical: 'center',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'center',
                    horizontal: 'left',
                } }, { children: _jsx(Paper, __assign({ sx: { p: 2, minWidth: '300px', maxWidth: '1000px' } }, { children: _jsx(ProfileQuickPreferenceEditor, { profile: props.profile, setProfile: function (p) {
                            props.setProfile(p);
                            handleClosePreferenceEditor();
                        }, open: openPreferenceEditor, preferenceTypes: [
                            COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY,
                            COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE,
                            COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL,
                        ] }) })) })), _jsx(Popover, __assign({ open: openContactEditor, anchorEl: anchorElContact, onClose: handleCloseContactEditor, anchorOrigin: {
                    vertical: 'center',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'center',
                    horizontal: 'left',
                } }, { children: _jsx(Paper, __assign({ sx: { p: 2, minWidth: '300px', maxWidth: '1000px' } }, { children: _jsx(ProfileQuickContactEditor, { profile: props.profile, setProfile: function (p) {
                            props.setProfile(p);
                            handleCloseContactEditor();
                        }, open: openContactEditor }) })) }))] })));
    if (showNewProfile) {
        return _jsx(ProfilePreview, { profile: profile, onProfileChange: props.setProfile, mode: props.mode, onOpenFullProfile: simple ? props.onChangeExpand : undefined, onBackToReservation: simple ? undefined : props.onChangeExpand, onRemoveFromReservation: props.onDelete, actions: !props.onDelete && !props.onChangeExpand && (_jsx(ProfileListActions, __assign({ profileId: profile.id }, { children: props.extraActions }))), reservationId: props.reservationId, reservation: props.reservation, otherGuests: props.otherGuests, bookingDetails: props.bookingDetails, onClose: props.onClose });
    }
    if (simple) {
        return simpleModeUI;
    }
    else {
        return (_jsxs(Stack, __assign({ sx: { height: '100%' } }, { children: [_jsx(Stack, __assign({ sx: {
                        backgroundColor: CommonThemeColors.sys.primary.main,
                        height: 40,
                        width: '100%',
                        justifyContent: 'center',
                        pl: 2,
                        pr: 2
                    } }, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 1, alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 1, alignItems: "center" }, { children: [_jsx(Box, { sx: {
                                            width: "12px",
                                            height: "12px",
                                            backgroundColor: stayStatusColor,
                                            borderRadius: "100%"
                                        } }), _jsx(Typography, __assign({ variant: 'h6', color: CommonThemeColors.sys.primary.contrastText }, { children: (_g = profile.nameOrdered) !== null && _g !== void 0 ? _g : profile.firstName + " " + profile.lastName }))] })), _jsx(Stack, __assign({ direction: "row", spacing: 1 }, { children: process.env.NODE_ENV === 'development' &&
                                    [['profile', profile.id], ['reservation', props.reservationId]]
                                        .filter(function (_a) {
                                        var id = _a[1];
                                        return !!id;
                                    })
                                        .map(function (_a) {
                                        var label = _a[0], id = _a[1];
                                        return (_jsx(Button, __assign({ size: "small", variant: "contained", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, navigator.clipboard.writeText(id !== null && id !== void 0 ? id : "")];
                                                        case 1:
                                                            _a.sent();
                                                            setCopied(id);
                                                            setTimeout(function () { return setCopied(undefined); }, 2000);
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); } }, { children: copied === id ? t("Copied!") : "".concat(label, ": ").concat(id) }), label));
                                    }) }))] })) })), _jsxs(Stack, __assign({ sx: {
                        width: '100%',
                        flexDirection: 'column',
                        '@media (min-width:768px)': {
                            flexDirection: "row"
                        }
                    } }, { children: [simpleModeUI, _jsx(Divider, { orientation: 'vertical', flexItem: true }), _jsx(FullProfileDetails, { profile: props.profile, 
                            // Make the interests section editable
                            setProfile: props.setProfile, voiceNoteId: voiceNoteId, setVoiceNoteId: setVoiceNoteId, sector: sector })] }))] })));
    }
};
export default ReservationProfile;
